import { lazy } from 'react';

/**
 * React.lazy로 지연 로딩하는 페이지 모음.
 *
 * 진입 필수 경로(Landing/Login/Register/FindAccount/ResetPassword)는
 * App.tsx에서 각 파일을 직접 eager import 하며, 이 파일에는 포함하지 않는다.
 * (여기서 재수출하면 barrel 특성상 eager 번들에 다시 합쳐질 수 있음)
 */

export const Home = lazy(() => import('./Home'));
export const CharacterCreate = lazy(() => import('./CharacterCreate'));
export const Map = lazy(() => import('./Map'));
export const StageDetail = lazy(() => import('./StageDetail'));
export const WorkoutRecord = lazy(() => import('./Workout/WorkoutRecordPage'));
export const WorkoutHistoryPage = lazy(() => import('./Workout/WorkoutHistoryPage'));
export const WorkoutStatsPage = lazy(() => import('./Workout/WorkoutStatsPage'));
export const Week0Page = lazy(() => import('./curriculum/Week0Page'));
export const Week1Page = lazy(() => import('./curriculum/Week1Page'));
export const ModuleDetailPage = lazy(() => import('./curriculum/ModuleDetailPage'));
export const Skills = lazy(() => import('./Skills'));
export const GradeInfo = lazy(() => import('./GradeInfo'));
export const Settings = lazy(() => import('./Settings'));
export const CustomExercises = lazy(() => import('./CustomExercises'));
export const CharacterProfile = lazy(() => import('./CharacterProfile'));
export const ProfileEdit = lazy(() => import('./ProfileEdit'));
export const LevelTestResult = lazy(() => import('./LevelTestResult'));
export const BodyTwin = lazy(() => import('./BodyTwin'));
export const Achievements = lazy(() => import('./Achievements'));
export const GoalSelect = lazy(() => import('./Onboarding/GoalSelect'));
export const InitialLevelTest = lazy(() => import('./Onboarding/InitialLevelTest'));
export const Programs = lazy(() => import('./Programs'));
export const ProgramDetail = lazy(() => import('./ProgramDetail'));
export const MyProgram = lazy(() => import('./MyProgram'));
export const PublicProfile = lazy(() => import('./PublicProfile'));
export const BoardsHome = lazy(() => import('./boards/BoardsHome'));
export const FreeBoard = lazy(() => import('./boards/FreeBoard'));
export const NoticeBoard = lazy(() => import('./boards/NoticeBoard'));
export const MapBoard = lazy(() => import('./boards/MapBoard'));
export const BoardPostDetail = lazy(() => import('./boards/BoardPostDetail'));
export const Shop = lazy(() => import('./Shop'));
export const Leaderboard = lazy(() => import('./Leaderboard'));
export const GymRegister = lazy(() => import('./GymRegister'));
export const DataTransfer = lazy(() => import('./DataTransfer'));
export const ChargePoints = lazy(() => import('./ChargePoints'));
export const PaymentSuccess = lazy(() => import('./PaymentSuccess'));
export const PaymentFail = lazy(() => import('./PaymentFail'));
export const VideoAnalysisPage = lazy(() => import('./VideoAnalysis/VideoAnalysisPage'));
export const VideoAnalysisDetail = lazy(() => import('./VideoAnalysis/VideoAnalysisDetail'));
export const Fragments = lazy(() => import('./Fragments'));

// Trainer
export const TrainerDashboard = lazy(() => import('./trainer/TrainerDashboard'));
export const TrainerLogin = lazy(() => import('./trainer/TrainerLogin'));
export const SubscriberList = lazy(() => import('./trainer/SubscriberList'));

// Admin
export const AdminDashboard = lazy(() => import('./admin/AdminDashboard'));
export const AdminLogin = lazy(() => import('./admin/AdminLogin'));
export const TrainerVerification = lazy(() => import('./admin/TrainerVerification'));
export const UserManagement = lazy(() => import('./admin/UserManagement'));
export const ProductCatalogManagement = lazy(() => import('./admin/ProductCatalogManagement'));
export const FragmentRedemptionManagement = lazy(() => import('./admin/FragmentRedemptionManagement'));
export const MapConfig = lazy(() => import('./admin/MapConfig'));
export const PaymentManagement = lazy(() => import('./admin/PaymentManagement'));
export const AdminSkillReviewPage = lazy(() => import('./admin/AdminSkillReviewPage'));
